import { render, staticRenderFns } from "./dogbreed.vue?vue&type=template&id=57049bfc&scoped=true&"
import script from "./dogbreed.vue?vue&type=script&lang=js&"
export * from "./dogbreed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57049bfc",
  null
  
)

export default component.exports